import React from 'react';
export const Header = () => {
  return <header className="bg-[#0C1B2A] text-white py-3 px-4 sm:px-6 flex flex-col sm:flex-row justify-between items-center" data-id="element-185">
      <p className="text-center sm:text-left text-sm font-medium mb-2 sm:mb-0" data-id="element-186">
        <span className="text-[#D4AF37] font-bold" data-id="element-187">¡OFERTA ESPECIAL!</span> •
        Garantía total de 7 días • Descarga inmediata
      </p>
      <a href="#checkout" className="btn-purchase bg-[#D4AF37] hover:bg-[#C5A028] text-[#0C1B2A] font-bold text-sm py-2 px-4 rounded-md transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37]" aria-label="Quiero la Guía" data-id="element-188">
        Quiero la Guía
      </a>
    </header>;
};